import {ComponentType, useMemo} from 'react';

import {useSelector} from 'react-redux';

import {PersonalAreaTabs} from '~/shared/consts/personalArea';
import Payments from '~/personalArea/components/Sections/Payments';
import MyBenefits from '~/personalArea/components/Sections/MyBenefits';
import MyTenbis from '~/personalArea/components/Sections/MyTenbis';
import MyOrders from '~/personalArea/components/Sections/MyOrders';
import Settings from '~/personalArea/components/Sections/Settings/Settings';
import PersonalArea from '~/personalArea/components/Sections/PersonalArea';
import {trackEvent} from '~/shared/services/analytics';
import {isJustEat} from '~/shared/config';
import {selectUserData} from '~/shared/store/storeModules/user';

export const DEFAULT_SECTION = PersonalAreaTabs.PERSONAL_AREA;

export type PersonalAreaSectionProps = {
  title: string;
  isMinLargeMobile?: boolean;
  query: string | null;
};

export type PersonalAreaSection = {
  id: PersonalAreaTabs;
  title: string;
  b2bTitle?: string;
  query: string | null;
  onClick?: () => void;
  component: ComponentType<PersonalAreaSectionProps>;
  showForCompanyUserOnDesktop?: boolean;
};

export type UsePersonalAreaSections = Record<string, PersonalAreaSection>;

const usePersonalAreaSections = (): UsePersonalAreaSections => {
  const userData = useSelector(selectUserData);

  return useMemo(() => ({
    [PersonalAreaTabs.PERSONAL_AREA]: {
      id: PersonalAreaTabs.PERSONAL_AREA,
      title: 'personal_area_page_personal_area_tab',
      query: null,
      onClick: () => trackEvent('personalArea_click'),
      component: PersonalArea,
    },
    ...(!isJustEat && userData?.isCompanyUser ? {[PersonalAreaTabs.MY_TENBIS]: {
      id: PersonalAreaTabs.MY_TENBIS,
      title: 'my_tenbis',
      query: 'my-tenbis',
      onClick: () => {},
      component: MyTenbis,
      showForCompanyUserOnDesktop: true,
    }} : {}),
    [PersonalAreaTabs.MY_ORDERS]: {
      id: PersonalAreaTabs.MY_ORDERS,
      title: userData?.isCompanyUser ? 'charges_report_2' : 'personal_area_page_my_orders_tab',
      query: 'my-orders',
      onClick: () => trackEvent('myOrdersArea_click'),
      component: MyOrders,
      showForCompanyUserOnDesktop: true,
    },
    [PersonalAreaTabs.PAYMENTS]: {
      id: PersonalAreaTabs.PAYMENTS,
      title: 'personal_area_page_payments_tab',
      query: 'payments',
      onClick: () => trackEvent('paymentMethods_click'),
      component: Payments,
      showForCompanyUserOnDesktop: true,
    },
    [PersonalAreaTabs.MY_BENEFITS]: {
      id: PersonalAreaTabs.MY_BENEFITS,
      title: 'personal_area_page_my_benefits_tab',
      query: 'my-benefits',
      onClick: () => trackEvent('myBenefits_click'),
      component: MyBenefits,
    },
    [PersonalAreaTabs.SETTINGS]: {
      id: PersonalAreaTabs.SETTINGS,
      title: 'personal_area_page_settings_tab',
      query: 'settings',
      onClick: () => trackEvent('settings_click'),
      component: Settings,
    },
  }), [userData?.isCompanyUser]);
};

export default usePersonalAreaSections;
